"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyActivityHttpClient = void 0;
const atlas_engine_sdk_1 = require("@atlas-engine/atlas_engine_sdk");
const index_1 = require("../Types/index");
const BaseClient_1 = require("./BaseClient");
const Mappers_1 = require("./Lib/Mappers");
class EmptyActivityHttpClient extends BaseClient_1.BaseClient {
    async query(query, identity, offset, limit, sortSettings) {
        const enhancedQuery = {
            ...query,
            flowNodeType: atlas_engine_sdk_1.BpmnType.emptyActivity,
        };
        const url = this.buildUrl(index_1.restSettings.paths.queryFlowNodeInstances, offset, limit, enhancedQuery, sortSettings);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const mappedResult = {
            totalCount: response.result.totalCount,
            emptyActivities: response.result.flowNodeInstances.map(Mappers_1.mapEmptyActivity),
        };
        return mappedResult;
    }
    async finishEmptyActivity(emptyActivityInstanceId, identity) {
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const urlRestPart = index_1.restSettings.paths.finishEmptyActivity
            .replace(index_1.restSettings.params.emptyActivityInstanceId, emptyActivityInstanceId);
        const url = this.buildUrl(urlRestPart);
        await this.httpClient.put(url, {}, requestAuthHeaders);
    }
    async onEmptyActivityWaiting(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.emptyActivityWaiting, callback, subscribeOnce, identity);
    }
    async onEmptyActivityFinished(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.emptyActivityFinished, callback, subscribeOnce, identity);
    }
    async removeSubscription(identity, subscription) {
        this.removeSocketIoSubscription(identity, subscription);
    }
}
exports.EmptyActivityHttpClient = EmptyActivityHttpClient;
//# sourceMappingURL=EmptyActivityHttpClient.js.map